<div class="vtr-menu-header" [ngClass]="{'germanClass':isGerman}">
	<ng-container *ngFor="let tab of menuItems; let i=index;">
		<div class="menu-header-tab {{tab.prop}}"
			tabindex="0"
			[routerLink]="['/' + tab.path, { outlets: tab.outlets}]"
			[routerLinkActive]="['active']"
			[routerLinkActiveOptions]="{exact: false}"
			(keydown.enter)="changeRoute(tab.path, tab.outlets)"
			role="link"
			id="myDevice-settings-header-menu-{{tab.icon}}"
			attr.aria-labelledby="myDevice-settings-header-menu-{{tab.icon}}-title">
			<div class="tab-label"
				title=""
				[matTooltip]="tab.label"
				matTooltipClass="vtr-system-tooltip"
				>
				<i class="icomoon {{tab.iconClass}}"></i>
				<span class="text"
					id="myDevice-settings-header-menu-{{tab.icon}}-title"
					attr.aria-label="myDevice-settings-header-menu-{{tab.label}}"
					aria-hidden="true">{{tab.label}}</span>
			</div>
			<fa-icon [icon]="['fas', 'square']"
				class="menu-pointer"
				role="img"
				alt="menu pointer square"
				aria-label="menu pointer square"></fa-icon>
		</div>
	</ng-container>
</div>
